<template class='event-list' v-infinite-scroll="loadMore" infinite-scroll-disabled="busy" infinite-scroll-distance="10">
  <div>
    <b-card class="my-2" v-if="events && loading===false"  v-for="event in events">
    <b-row class="py-2 px-3">
        <b-col cols="auto">
            <img v-if="event.background_file==null" src="/images/no_image-1000x1000.png" 
                alt="" class="pr-1" style="height:300px; border-radius: 3px; float: left;">
            <img v-else :src="event.background_file" 
                alt="" class="pr-2" style="height:300px; border-radius: 3px; float: left;">

        </b-col>  
        <b-col>
                          <div class="font-size-14">
                <b-button v-show="$auth.check()" variant="outline-dark" class=" pull-right font-size-24" :title="$t('fav')"  v-on:click="$root.toFavorite(event.id,'event',event.name); event.isFavorite=!event.isFavorite"><i v-bind:class="{'fa-star':event.isFavorite, 'fa-star-o':!event.isFavorite}" class="fa"></i></b-button>
                <router-link :to="{ path: '/events/' + event.id }" class="widget-followers-name"> <h4 style="margin-bottom: 5px;">{{event.name}} </h4></router-link> 
            </div>
              <div style="display: inline" v-if="event.area_of_interest"><b-badge v-for="(item, index) in JSON.parse(event.area_of_interest)" :key="index" variant="primary" class="m-1">{{item}}</b-badge></div>
              <p>{{event.description}}</p>
            <router-link v-show="$moment(event.send_deadline).tz($moment.tz.guess())>$moment(new Date()).tz($moment.tz.guess()) && event.prev===0 && $auth.check()" :to="{ path: '/events/' + event.id + '/participate' }" class="btn btn-success">{{ $t('part1') }} </router-link>
            <router-link v-show="$moment(event.send_deadline).tz($moment.tz.guess())>$moment(new Date()).tz($moment.tz.guess()) && event.prev===0 && !$auth.check()" :to="{ path: '/register' }" class="btn btn-success">{{ $t('part1') }} </router-link>

        </b-col>
        </b-row>


</b-card>
      </div>
    
  

</template>

<i18n>
{
  "en": {
    "fav": "Add to favorites",
    "info": "(Not activated. Wait for moderation)",
    "part": "Type of participation:",
    "full": "Full time",  
    "ex": "In absentia",     
    "fuex": "Full time with absentee participation",
    "reg": "Registration frame",     
    "state": "Status:",    
    "closed": "Completed",     
    "gas": "Collection of publications",
    "vi": "Review",    
    "pay": "Receiving payment",    
    "cond": "Preparation",     
    "part1": "Participate"     
    
    
    
  },
  "ru": {
    "fav": "Добавить в избранное",
    "info": "(Не активировано. Ожидайте проверки модератором)",
    "part": "Тип участия:",
    "full": "Очное",
    "ex": "Заочное",
    "fuex": "Очное с заочным участием",
    "reg": "Регистрация",     
    "state": "Статус",    
    "closed": "Завершено",     
    "gas": "Сбор публикаций",
    "vi": "Рецензирование",    
    "pay": "Прием оплаты",    
    "cond": "Подготовка к проведению",     
    "part1": "Принять участие"  

   }
}
</i18n>












<script>
import InfiniteLoading from 'vue-infinite-loading'

const debounce = function (f, ms) {
  let timer = null;
  return function (...args) {
      const onComplete = () => {
          f.apply(this, args);
          timer = null;
      }
      if (timer) {
          clearTimeout(timer);
      }
      timer = setTimeout(onComplete, ms);
  };
}
export default {
  name: 'event-list',
  components: {
    InfiniteLoading
  },
  props: ['tab','searchString'],
  data () {
    return {
      events: [],
      errors: [],
      busy: false,
      loading:true
    }
  },
  // Fetches posts when the component is created.
  created () {
    this.fetchData()
  },
  watch: {
    // при изменениях маршрута запрашиваем данные снова
    '$route': 'fetchData',
    tab: 'fetchData',
    searchString (after, before) {
      this.search()
    }
  },
  methods: {
    search: debounce(function () {
      this.fetchData()
    }, 500),
    fetchData () {
        this.loading=true
      this.$http.post('event/list?tab='+this.tab+'&page=1', {
          EventListSearch:this.searchString,
      })
      .then(response => {
        // JSON responses are automatically parsed.
        this.events = response.data
        this.loading=false
      })
      .catch(e => {
        this.errors.push(e)
      })
    },
    infiniteHandler ($state) {
      if ((this.events.length / 20) === parseInt((this.events.length / 20), 10)) {
         var page = this.events.length / 20 + 1;
        this.$http.post('event/list?tab='+this.tab+'&page=' + page, {
          EventListSearch:this.searchString,
        }).then(({ data }) => {
          if (data.length) {
            this.events = this.events.concat(data)
            $state.loaded()
            if (this.events.length / 20 === 10) {
              $state.complete()
            }
          } else {
            $state.complete()
          }
        })
      } else {
        $state.complete()
      }
    }
  }
}
</script>